import React from 'react';
import ProductMediaFigure from '../../shared/ProductMediaFigure';
import { MEDIA_PLACEMENTS } from '../../../../content/productMedia';

const bands = [
  {
    eyebrow: 'Split-screen workflow',
    title: 'Copilot chat with embedded BI in one session',
    body:
      'Ask workforce questions on the left; the right column syncs governed Power BI bookmarks and editable dynamic charts, all backed by Snowflake Cortex Intelligence.',
    ids: MEDIA_PLACEMENTS.splitScreenProof,
  },
  {
    eyebrow: 'Copilot chat column',
    title: 'Charts, tables, and narrative without leaving the thread',
    body:
      'Headcount, attrition, hiring gaps, and plan-vs-actual, each turn returns governed SQL, visualizations, and follow-up prompts before the gallery updates.',
    ids: MEDIA_PLACEMENTS.chatColumn,
  },
  {
    eyebrow: 'Workforce planning & attrition',
    title: 'From headline metrics to executive narrative',
    body:
      'Progressive inquiry across headcount movement, hiring gaps, backfill rates, and termination pressure, the scenarios CHRO and people analytics teams run every week.',
    ids: [...MEDIA_PLACEMENTS.workforcePlanning.slice(0, 2), ...MEDIA_PLACEMENTS.attrition.slice(1, 3)],
  },
];

export default function ProductMediaShowcase() {
  return (
    <section className="section">
      <div className="container-x">
        <div className="max-w-3xl mb-12 lg:mb-16">
          <p className="eyebrow">Product in action</p>
          <h2 className="mt-3 text-3xl sm:text-4xl font-semibold tracking-tight text-ink-900">
            Semantic HR in the workforce analytics session
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-600">
            Real captures from the split-screen React application, copilot chat, embedded Power BI gallery,
            dynamic visualizations, and multi-turn workforce analytics on Snowflake.
          </p>
        </div>

        <div className="space-y-16 lg:space-y-20">
          {bands.map((band, i) => (
            <div
              key={band.title}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start ${
                i % 2 === 1 ? 'lg:[&>div:first-child]:order-2' : ''
              }`}
            >
              <div className={i % 2 === 1 ? 'lg:order-2' : ''}>
                <p className="eyebrow">{band.eyebrow}</p>
                <h3 className="mt-3 text-2xl font-semibold tracking-tight text-ink-900">{band.title}</h3>
                <p className="mt-4 text-base text-ink-600 leading-relaxed">{band.body}</p>
              </div>
              <div className={`space-y-4 ${i % 2 === 1 ? 'lg:order-1' : ''}`}>
                {band.ids.map((id) => (
                  <ProductMediaFigure key={id} id={id} aspect="natural" />
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {MEDIA_PLACEMENTS.hiringRecruiting.map((id) => (
            <ProductMediaFigure key={id} id={id} aspect="natural" showCaption />
          ))}
        </div>
      </div>
    </section>
  );
}
